import { PersonInAssetType } from "../enums";
import { IMediaPersonModel } from "../models";

export const filterPeopleByRole = (
  people: IMediaPersonModel[] | undefined,
  role: PersonInAssetType
) => {
  return people?.filter(
    (person) => person.PersonRoleCode && person.PersonRoleCode === role
  );
};

/**
 * RedBee qualifies the role with the dubbing language, e.g. "Dubbing Actor
 * (dan)" in Denmark and "Dubbing Actor (fin)" in Finland.
 */
export const filterDubbingActors = (people: IMediaPersonModel[] | undefined) =>
  people?.filter((person) =>
    person.PersonRoleCode?.startsWith(PersonInAssetType.DubbingActor)
  );
